import React, { useState } from 'react'
import { CircularProgress, IconButton, Tooltip } from '@mui/material'
import { Error, Check } from '@mui/icons-material'
import Button from '@mui/material/Button'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'

import Colors from 'utils/Colors'
import { patch } from 'services/api'
import { DialogConfirm } from 'components'
import styles from '../styles'

const CreateMissingCreditAnalysisButton = ({ application, onUpdateDataRequest, useTitle = false  }) => {
  const [loading, setLoading] = useState(false)
  const [requested, setRequested] = useState(false)
  const [openConfirm, setOpenConfirm] = useState(false)

  const classes = styles()

  const token = useSelector((state) => state.auth.access_token)

  const handleOpenConfirm = () => {
    if (requested) {
      return
    }
    setOpenConfirm(true)
  }

  const handleCloseConfirm = () => setOpenConfirm(false)

  const handleClickRequest = async (id) => {
    setOpenConfirm(false)
    setLoading(true)

    const res = await patch({
      url: '/application/create-missing-credit-analysis',
      token,
      data: {
        application_uuid: id,
      },
    })

    if (res) {
      toast.success(
        'Análise de crédito solicitada. Os dados deverão ser atualizados em alguns instantes',
      )
      setRequested(true)
    }

    onUpdateDataRequest()
    setLoading(false)
  }

  const selectIcon = () => {
    if (requested) {
      return <Check size={20} style={{ color: Colors.approvedGreen }} />
    } if (loading) {
      return <CircularProgress size={20} color="primary" />
    }
    return (
      <Error
        style={{
          color: Colors.errorYellow,
          fontSize: 20,
        }}
      />
    )
  }

  const renderIconButton = () => (
    <IconButton
      onClick={handleOpenConfirm}
      size="large"
    >
      {selectIcon()}
    </IconButton>
  )

  const renderLabeledButton = () => (
    <Button
      size="small"
      variant="outlined"
      onClick={handleOpenConfirm}
      startIcon={selectIcon()}
    >
      {!requested ? 'Realizar Análise de Crédito' : 'Solicitado'}
    </Button>
  )

  const renderButton = () => (
    !useTitle && loading ? (
      <CircularProgress size={18} color="primary" />
    ) : (
      <Tooltip
        arrow
        placement="top"
        title={
          <b className={classes.tooltipText}>
            {!requested ? 'Solicitar a realização da análise de crédito para esta aplicação.' : 'Análise de crédito solicitada.'}
          </b>
        }
      >
        {useTitle ? renderLabeledButton() : renderIconButton()}
      </Tooltip>
    )
  )

  return (
    <React.Fragment>
      {renderButton()}

      <DialogConfirm
        open={openConfirm}
        title="Realizar Análise de Crédito faltante?"
        btnConfirmText="Sim"
        btnCancelText="Cancelar"
        onCancel={handleCloseConfirm}
        onConfirm={() => handleClickRequest(application?.uuid)}
      >
        Essa aplicação teve o BGC concluído, mas não passou pela Análise de Crédito, pois se trata de uma jornada feita
        no sistema antigo em que essa Análise era uma etapa separada do BGC.
        <br />
        <br />
        Prosseguir?
        <br />
        <br />
        <b>Custos adicionais serão aplicados ao billing mensal.</b>
      </DialogConfirm>
    </React.Fragment>
  )
}

export default CreateMissingCreditAnalysisButton
